// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected-filters[data-v-76443a9b]{display:flex;gap:4px}.selected-filters__item[data-v-76443a9b]{align-items:center;background-color:var(--active-color);border-radius:8px;cursor:pointer;display:flex;padding:4px 12px}.selected-filters__item-text[data-v-76443a9b]{font-size:.8em;line-height:1.9em;margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
